<template>
  <div v-if="show" class="modalSliderContainer">
    <div class="sliderMask" @click="close" />
    <div class="modalSliderContentWrapper w-100" :class="{'showing': canShowContent}">
      <button class="btn modalCloseIcon" @click="close">
        <Close fill="#FFF" height="25px" width="25px"/>
      </button>
      <div class="modalSliderContent">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Close from '@js/web/components/icons/Close.vue';

export default {
  name: 'ModalSlider',
  components: { Close },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      canShowContent: false
    };
  },
  watch: {
    show(canShow) {
      if (!canShow) {
        document.body.style.overflow = 'auto';
      } else {
        document.body.style.overflow = 'hidden';
      }

      setTimeout(() => {
        this.canShowContent = canShow;
      }, 100);
    }
  },
  methods: {
    close() {
      this.canShowContent = false;
      setTimeout(() => {
        this.$emit('close');
      }, 500);
    }
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';

.modalSliderContainer {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 2000;
  @include media-breakpoint-down(xs) {
    padding-top: 50px;
  }

  .sliderMask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .9);

    &:hover {
      cursor: pointer;
    }
  }

  .modalSliderContentWrapper {
    position: relative;
    top: 120%;
    height: 100%;
    transition: all .5s ease-in-out;

    &.showing {
      top: 0;
    }

    .modalCloseIcon {
      position: absolute;
      top: -50px;
      right: 35px;
      padding: 0;
      @include media-breakpoint-down(xs) {
        top: -40px;
        right: 20px;
      }
    }

    .modalSliderContent {
      background: #FFF;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      width: 100%;
      height: 100%;
      max-height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}
</style>